<template>
  <div class="card card-chat-booking-text"
       :class="[(message.sender_type === 'user') ? 'float-right chat-user-color -white': 'float-left ml-3']">
    <div class="card-body">
      <span v-html="message.text"></span>
      <div class="pt-2" v-if="message.optional_text">
        {{ message.optional_text }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      message: Object
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/TextMessage.vue